export default "__VITE_ASSET__izyQZt6p__"